import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React from "react";
import { X } from "lucide-react";
import styles from "../../_css/ContenetManagement.module.css";

const DeleteTutorialModal = ({ show, onHide, onDelete }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-37"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className={styles.deleteTutorialModalContainer}>
                    {/* Close Icon */}
                    <X
                        onClick={onHide}
                        className={styles.deleteTutorialModalCloseIcon}
                        size={24}
                    />

                    {/* Header with Image and Title */}
                    <div className={styles.deleteTutorialModalHeader}>
                        <img
                            className={styles.deleteTutorialModalImage}
                            src={`${process.env.PUBLIC_URL}/img/delete-icon.png`}
                            alt="Delete Icon"
                        />
                        <h1 className={styles.deleteTutorialModalTitle}>Delete Tutorial?</h1>
                    </div>

                    {/* Buttons in same line */}
                    <div className={styles.deleteTutorialModalButtonContainer}>
                        <button
                            className={styles.deleteTutorialModalBackButton}
                            onClick={() => onHide()}
                        >
                            Back
                        </button>
                        <button
                            className={styles.deleteTutorialModalDeleteButton}
                            onClick={() => {
                                onDelete();
                            }}
                        >
                            Remove Tutorial
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteTutorialModal;